import { useEffect, useState } from "react";
import axios from "axios";
import { CreditCard } from "lucide-react";
import { API_URL } from "../../lib/utils";

export const useTPAs = (headers, enabled = true) => {
  const [tpas, setTpas] = useState([]);
  useEffect(() => {
    if (!enabled) return;
    axios.get(`${API_URL}/tpas`, { headers, withCredentials: true }).then((r) => setTpas(r.data || [])).catch(() => setTpas([]));
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  return tpas;
};

// Escolha do terminal (TPA) em pagamentos com cartão — obrigatório quando a empresa tem TPAs configurados
export const TPASelector = ({ tpas, value, onChange, dark = false, hint }) => {
  if (!tpas?.length) return null;
  const base = dark
    ? { on: "bg-blue-600 border-blue-500 text-white", off: "bg-muted border-border hover:border-blue-500/60" }
    : { on: "bg-primary border-primary text-primary-foreground", off: "bg-background border-input hover:border-primary/60" };
  return (
    <div className="space-y-1.5" data-testid="tpa-selector">
      <label className="text-xs text-muted-foreground flex items-center gap-1"><CreditCard className="w-3.5 h-3.5" /> TPA onde o cartão foi passado {hint ? <span className="italic">— {hint}</span> : <span className="text-destructive">*</span>}</label>
      <div className="grid grid-cols-2 gap-1.5">
        {tpas.map((t) => (
          <button
            key={t.tpa_id}
            type="button"
            onClick={() => onChange(t.tpa_id)}
            className={`h-10 rounded-md border px-2 text-left text-xs transition-colors ${value === t.tpa_id ? base.on : base.off}`}
            data-testid={`tpa-option-${t.tpa_id}`}
          >
            <span className="block font-semibold truncate">{t.name}</span>
            <span className={`block text-[10px] truncate ${value === t.tpa_id ? "opacity-80" : "text-muted-foreground"}`}>{[t.bank_name, t.account_name].filter(Boolean).join(" · ") || t.serial || "—"}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
